import React from "react";
import Components from "../services/ComponentsD";
import Cookies from 'js-cookie'
import axios from "axios";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'

function TabDefaultComponent({
  name,
  object,
  index,
  useVals,
  setTabs,
  active,

  setTabsImage,
  isadmin,
  setObject2,
}) {
  // object[name].where iamage_type == amazon pe image uplaod ki hai
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [list, setList] = React.useState();
  React.useEffect(() => {
    setList(object[name])
  }, [object]);
  const initialDnDState = {
    draggedFrom: null,
    draggedTo: null,
    isDragging: false,
    originalOrder: [],
    updatedOrder: []
  }
  const [dragAndDrop, setDragAndDrop] = React.useState(initialDnDState);
  // Not needed, just for logging purposes:



  const [sortedList, setSortedList] = React.useState()
  const onDragStart = (event) => {
    const myList = list;
    console.log(myList)
    const findIndexById = (id) => {
      return myList.findIndex(item => item.ParameterId === id);
    };
    let checkid = event.target.id;
    let structuretype = checkid.split('-');
    const searchId = structuretype[1];
    const index = findIndexById(Number(searchId));
    console.log(index)
    const initialPosition = Number(index);

    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: initialPosition,
      isDragging: true,
      originalOrder: list
    });

    event.dataTransfer.setData("text/html", '');
  }

  const onDragOver = (event) => {

    event.preventDefault();

    let newList = dragAndDrop.originalOrder;
    const draggedFrom = dragAndDrop.draggedFrom;
    const findIndexById = (id) => {
      return newList.findIndex(item => item.ParameterId === id);
    };
    let checkid = event.target.id;
    let structuretype = checkid.split('-');
    const searchId = structuretype[1];
    const draggedTo = findIndexById(Number(searchId));
    //const draggedTo = Number(event.currentTarget.dataset.position); 
    if (draggedTo != -1) {
      const itemDragged = newList[draggedFrom];
      const remainingItems = newList.filter((item, index) => index !== draggedFrom);

      newList = [
        ...remainingItems.slice(0, draggedTo),
        itemDragged,
        ...remainingItems.slice(draggedTo)
      ];


      setDragAndDrop({
        ...dragAndDrop,
        updatedOrder: newList,
        draggedTo: draggedTo
      })

    }
  }

  const onDrop = (event) => {
    console.log(dragAndDrop.updatedOrder)
    setList(dragAndDrop.updatedOrder);

    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: null,
      draggedTo: null,
      isDragging: false
    });
  }


  const onDragLeave = () => {
    setDragAndDrop({
      ...dragAndDrop,
      draggedTo: null
    });

  }

  React.useEffect(() => {
    console.log("Dragged From: ", dragAndDrop && dragAndDrop.draggedFrom);
    console.log("Dropping Into: ", dragAndDrop && dragAndDrop.draggedTo);
  }, [dragAndDrop])





  React.useEffect(() => {

    var formID = 0;
    console.log(list)
    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSaveOrder",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: active,
      Calculations: list,
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    console.log("List updated!");
    console.log(params)
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
        alert(e.message);
      });


  }, [list])



  if (name != null) {

    return (


      <div class="card-header" >
        <h5 class="mb-0">
          <button type="button"
            class="btn btn-link  w-100 d-flex justify-content-between align-items-center collapsed"
          >

            <div class="left">

              <span> {name === "StructureImages" ? "Structure Images" : name}</span>
            </div>

            {/* <div class="right" >
              
              {isComplete==0?(  <span class="com-not">Not Complete</span>):( <span class="com-not complete">Complete</span>)}
              
             
            
              </div> */}
          </button>
        </h5>


        {/* <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-left"
            type="button"
            data-toggle="collapse"
            data-target={`#collapse${index}`}
            aria-expanded="true"
            aria-controls={`collapse${index}`}
          >
           
          </button>
        </h2>
      </div> */}

        {name !== "StructureImages" ? (
          <div
            id={`collapse${index}`}
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >

            {(name == "Building Cost Breakdown") ? (

              <div class="row justify-content-end">

                <div class="col-xl-8 col-lg-8">
                  <div class="table-outer">


                    <div class="word row mytable " >

                      {list && object &&
                        object[name] && list.map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop} onDragLeave={onDragLeave} dragAndDrop={dragAndDrop} />)}
                      {/* {object &&
                    object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object[name]} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop} onDragLeave={onDragLeave} />)}
                     */}
                      {/* <div class="row advharddef " id="advharddef">
                  {object &&
                    object[name].map((item) => Components(item, object[name], setObject2, useVals,12,object,""))}
                    </div>
                    <div class="row advsoftdef " id="advsoftdef">
                  {object &&
                    object[name].map((item) => Components(item, object[name], setObject2, useVals,11,object,""))}
                    </div> */}

                    </div>



                  </div>
                </div>

                <div class="col-xl-3 col-lg-4 text-center " style={{ marginTop: "7%" }}>
                  <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                    <div class="cross"  >

                    </div>
                    <h6 class="text-left" id={"H" + name + active}>

                    </h6>
                    <p class="text-left" id={"I" + name + active}>

                    </p>

                  </div>

                </div>
              </div>
            ) : (
              (name == "Sales Cost Breakdown" || name == "Proforma Breakdown" || name == "Land Analysis") ? (

                <div class="row justify-content-end">
                  <div class="col-xl-8 col-lg-8">
                    <div class="table-outer">


                      <div class="row mytable ">

                        {list && object &&
                          object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />)}

                      </div>



                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-4 text-center " style={{ marginTop: "7%" }}>
                    <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                      <div class="cross"  >

                      </div>
                      <h6 class="text-left" id={"H" + name + active}>

                      </h6>
                      <p class="text-left" id={"I" + name + active}>

                      </p>

                    </div>

                  </div>
                </div>
              ) : (
                <div class="row justify-content-end">
                  {name == "Site Potential" ? (
                    <>
                      {/* {object && object[name].map((item) => Components(item, object[name], setObject2, useVals,5,object,""))} */}

                      {/* {list &&  object &&
                    object[name].map((item) => <Components item={item} data={object[name]} setObject2={setObject2} useVals={useVals} IsSite={5} object={object}   />)} */}
                      <div class="col-xl-8 col-lg-8 ">



                        <div class=" table-outer">

                          <div class="row mytable " style={{ width: "107%" }}>

                            {/* {object && object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}
                            {list && object &&
                              object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />)}
                            {list && object &&
                              object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={1} object={object} />)}
                            {/* {object && object[name].map((item) => Components(item, object[name], setObject2, useVals,1,object,""))}    */}
                          </div>
                        </div>
                      </div>



                      <div class="col-xl-3 col-lg-4 text-center " >
                        <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                          <div class="cross" >

                          </div>
                          <h6 class="text-left" id={"H" + name + active}>

                          </h6>
                          <p class="text-left" id={"I" + name + active}>

                          </p>

                        </div>

                      </div>
                    </>) :
                    (<> <div class="col-xl-9 col-lg-8"> <form class="input-box1 ">
                      <div class="row financingdiv " id="loan">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}
                        {list && object &&
                          object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />)}
                      </div>
                      <div class="row financingdiv " id="cons">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,1,object,""))} */}
                        {list && object &&
                          object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={1} object={object} />)}
                      </div>
                      <div class="row financingdiv " id="ext">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,2,object,""))} */}
                        {list && object &&
                          object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={2} object={object} />)}
                      </div>
                      <div class="row " style={{ width: "95%" }}>
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,3,object,""))} */}
                        {list && object &&
                          object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={3} object={object} />)}
                      </div>
                    </form> </div> <div class="col-xl-2 col-lg-2 text-center " >


                      </div></>)}

                </div>
              )
            )
            }

          </div>

        ) : (
          // <div style={{ margin: "3%" }} class="row">
          //   {images &&
          //     images.map((item) => (
          //       <div class="col-md-4">
          //         <div class="profile-pic-change d-flex">
          //           <img
          //             src={item.image_url}
          //             alt="User Image"
          //             class="user-avatar"
          //             id={`${
          //               item.image_type + item.structure_type_id + item.image_url
          //             }`}
          //             key={`${
          //               item.image_type + item.structure_type_id + item.image_url
          //             }`}
          //           ></img>
          //           <div class="form-group">
          //             <label class="ml-3">{item.image_type}</label>

          //            </div>
          //           {/* <i class="far fa-trash-alt icon-del"></i> */}
          //         </div> 
          //       </div>
          //     ))}
          // </div>
          <></>
        )}
      </div>
    );
  }
  {
    return (null);
  }
}

export default TabDefaultComponent;
